import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import Splash from 'partial/containers/Splash';
import { MyAccountContext } from '../constants';
import { useCurrentAccount } from '../hooks';

function MyAccountWrapper({ children }) {
  const [isLoading, activeAccount] = useCurrentAccount();
  if (isLoading && isEmpty(activeAccount)) return <Splash />;
  return (
    <MyAccountContext.Provider value={{ activeAccount }}>
      {children}
    </MyAccountContext.Provider>
  );
}

MyAccountWrapper.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export default MyAccountWrapper;
